/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { getgeneralsystemparameterDetails } from '../../../../System/systemParameter/store/actions';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import {
  dispatchContactDetailsClient,
  dispatchExistingContactDetailsClient,
  setIsValidContactForm,
} from '../../../Plan/store/actions';
import { setReduxDataIntoSearchScr, setTabValue } from '../../store/actions';
import { redirectURLLink } from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { checkActionAccessByRole } from '../../../../../SharedModules/utilities/utilities';

const ClientSearchCriteria = ({
  history,
  setSelectedClient,
  selectedClient,
}) => {
  const dispatch = useDispatch();
  const reduxDataSearchScreen = useSelector((state) => {
    return state.sharedState.ClientReducer.searchScreenData;
  });
  const generalSystemParameterDetails = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.generalSystemParameter
        ?.paramGeneralVO
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [hasAccessbyRole, setHasAccessbyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  useEffect(() => {
    dispatch(getgeneralsystemparameterDetails());
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccessbyRole(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  const redirectToMaintain = () => {
    window.localStorage.setItem('clientSearchOrAdd', 'add');
    dispatch(setIsValidContactForm(false));
    dispatch(setTabValue(0));
    redirectURLLink('/maintain', 'Maintain Client', history, dispatch);
    dispatch(dispatchContactDetailsClient([]));
    dispatch(dispatchExistingContactDetailsClient([]));
    dispatch(
      setReduxDataIntoSearchScr({
        ...reduxDataSearchScreen,
        currentIndex: null,
      })
    );
  };
  return (
    <div className="no-margin" style={{ width: '99%' }}>
      <div className="form-wrapper">
        <div className="mui-custom-form no-margin override-width-38">
          <fieldset className="custom-fieldset" style={{ width: '80%' }}>
            <legend className="same-font-family">Search Criteria</legend>

            <div className="form-wrapper db">
              <div
                className="sub-radio no-margin"
                id="demo-row-radio-buttons-group-label"
              >
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue={selectedClient}
                    value={selectedClient}
                  >
                    <FormControlLabel
                      value="Rebate Program Code"
                      control={
                        <Radio
                          onChange={() => {
                            setSelectedClient('Rebate Program Code');
                            dispatch(
                              setReduxDataIntoSearchScr({
                                ...reduxDataSearchScreen,
                                state: { selectClient: 'Rebate Program Code' },
                                currentIndex:null
                              })
                            );
                          }}
                        />
                      }
                      label="Rebate Program Code"
                      data-test="rebate-program-code"
                    />
                    <FormControlLabel
                      value="Super Client"
                      control={
                        <Radio
                          onChange={() => {
                            setSelectedClient('Super Client');
                            dispatch(
                              setReduxDataIntoSearchScr({
                                ...reduxDataSearchScreen,
                                state: { selectClient: 'Super Client' },
                                currentIndex:null

                              })
                            );
                          }}
                        />
                      }
                      label="Super Client"
                      data-test="super-client"
                    />
                    <FormControlLabel
                      value="Client"
                      control={
                        <Radio
                          onChange={() => {
                            setSelectedClient('Client');
                            dispatch(
                              setReduxDataIntoSearchScr({
                                ...reduxDataSearchScreen,
                                state: { selectClient: 'Client' },
                                currentIndex:null

                              })
                            );
                          }}
                        />
                      }
                      label="Client"
                      data-test="client"
                    />
                    <FormControlLabel
                      value="Group"
                      control={
                        <Radio
                          onChange={() => {
                            setSelectedClient('Group');
                            dispatch(
                              setReduxDataIntoSearchScr({
                                ...reduxDataSearchScreen,
                                state: { selectClient: 'Group' },
                                currentIndex:null

                              })
                            );
                          }}
                        />
                      }
                      label="Group"
                      data-test="group"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
          </fieldset>
        </div>
        <div
          className="float-right  hide-on-print"
          style={{ marginBottom: '10px', marginTop: '0.75rem' }}
        >
          {generalSystemParameterDetails?.[0]?.allowNewCgpInd === 1 ? (
            <Button
              className="btn-success same-font-family"
              onClick={redirectToMaintain}
              disabled={isEnablebyRole === false}
            >
              <SVGComponent iconName="Create-new-icon" />
              {'  '} Create New Client
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default withRouter(ClientSearchCriteria);
